module.exports = __webpack_public_path__ + "static/media/trip.ebaa14d7.svg";